export default {
  minPrice: {
    id: 'landing_price_filter_min',
    defaultMessage: 'Min ({currency})',
  },
  maxPrice: {
    id: 'landing_price_filter_max',
    defaultMessage: 'Max ({currency})',
  },
}
